import { render, staticRenderFns } from "./HomepageV2.vue?vue&type=template&id=edaff622&scoped=true"
import script from "./HomepageV2.vue?vue&type=script&lang=js"
export * from "./HomepageV2.vue?vue&type=script&lang=js"
import style0 from "./HomepageV2.vue?vue&type=style&index=0&id=edaff622&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaff622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edaff622')) {
      api.createRecord('edaff622', component.options)
    } else {
      api.reload('edaff622', component.options)
    }
    module.hot.accept("./HomepageV2.vue?vue&type=template&id=edaff622&scoped=true", function () {
      api.rerender('edaff622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/HomepageV2.vue"
export default component.exports